import { Box } from "@mui/material";
import React from "react";

const ThreeCardSpread = ({
    size,
    displaySpread,
    getCard
}: {
    size: number,
    displaySpread: boolean,
    getCard: (index: number) => React.ReactNode
}) => {
    return (
        <Box sx={{
            display: displaySpread ? 'grid' : 'none',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: 1,
            padding: "5px",
            width: '100%',
            height: '100%',
            margin: '0 auto',
            overflow: 'hidden',
            alignItems: 'center',
            justifyItems: 'center'
        }}>
            {Array.from({ length: 3 }, (_, index) => (
                <React.Fragment key={`three-card-item-${index}`}>
                    {getCard(index)}
                </React.Fragment>
            ))}
        </Box>
    );
};

export default ThreeCardSpread; 